'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_samples$002e$002dPersons$0024package$0024$002dHouse$00242 from "./samples.-Persons$package$-House$2.js";
var $p;
/** @constructor */
function $c_Lsamples_Persons$package$House$4$() {
}
export { $c_Lsamples_Persons$package$House$4$ as $c_Lsamples_Persons$package$House$4$ };
$p = $c_Lsamples_Persons$package$House$4$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_Persons$package$House$4$;
/** @constructor */
function $h_Lsamples_Persons$package$House$4$() {
}
export { $h_Lsamples_Persons$package$House$4$ as $h_Lsamples_Persons$package$House$4$ };
$h_Lsamples_Persons$package$House$4$.prototype = $p;
$p.b = (function() {
  return "House";
});
$p.Uz = (function(x$0) {
  return new $j_samples$002e$002dPersons$0024package$0024$002dHouse$00242.$c_Lsamples_Persons$package$House$2((x$0.g(0) | 0));
});
$p.y = (function(p) {
  return this.Uz(p);
});
var $d_Lsamples_Persons$package$House$4$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_Persons$package$House$4$, "samples.Persons$package$House$4$", ({
  q8: 1,
  e: 1,
  g: 1
}));
export { $d_Lsamples_Persons$package$House$4$ as $d_Lsamples_Persons$package$House$4$ };
